// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getResult = (key: string, allEnv: any) => {
  const value = allEnv.public[key];
  const baseErrorMessage = 'Did you configure `.env` file? - Learn more: https://github.com/gradguard/nuxt-monorepo?tab=readme-ov-file#prepare-environment';
  if (!value) {
    return {
      isError: true,
      message: `Environment variable '${key}' is not set in the runtime config`,
      text: baseErrorMessage,
    };
  }
  if (typeof value !== 'string') {
    return {
      isError: true,
      message: `Environment variable '${key}' is not a string in the runtime config`,
      text: baseErrorMessage,
    };
  }
  if (value.trim() === '') {
    return {
      isError: true,
      message: `Environment variable '${key}' is empty in the runtime config`,
      text: baseErrorMessage,
    };
  }
  return {
    isError: false,
    value,
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getConfigString = (key: string, allEnv: any): string => {
  const result = getResult(key, allEnv);
  if ('value' in result && result.value !== undefined) {
    return result.value;
  }
  throw createError({
    statusCode: 500,
    statusText: result.text,
    statusMessage: result.message,
  });
};
